import React from "react";

import MainTemplate from "../../containers/MainTemplate";
import CollageGallery from "../../components/CollageGallery";

import carbonMobile from "../../assets/carbon_method/carbon-mobile.webp";
import carbonDesktop from "../../assets/carbon_method/carbon-desktop.webp";
import carbonDesktop2 from "../../assets/carbon_method/carbon-desktop2.webp";
import carbonDesktop3 from "../../assets/carbon_method/carbon-desktop3.webp";

import deutscheMobile from "../../assets/deutscheinvest/deutsche-mobile.webp";
import deutscheMobile2 from "../../assets/deutscheinvest/deutsche-mobile-2.webp";
import deutscheMobile3 from "../../assets/deutscheinvest/deutsche-mobile-3.webp";
import deutscheDesktop from "../../assets/deutscheinvest/deutsche-desktop.webp";
import deutscheDesktop2 from "../../assets/deutscheinvest/deutsche-desktop-2.webp";
import deutscheDesktop3 from "../../assets/deutscheinvest/deutsche-desktop-3.webp";
import deutscheDesktop4 from "../../assets/deutscheinvest/deutsche-desktop-4.webp";

import bpDesktop from "../../assets/bp/bp-desktop.webp";
import bpDesktop2 from "../../assets/bp/bp-desktop2.webp";
import bpMobile from "../../assets/bp/bp-mobile.webp";

import o2Mobile from "../../assets/o2/o2-mobile.webp";
import o2Desktop from "../../assets/o2/o2-desktop.webp";
import o2Desktop2 from "../../assets/o2/o2-desktop2.webp";

import newshackerDesktop from "../../assets/newshacker/newshacker-desktop.webp";
import newshackerDesktop1 from "../../assets/newshacker/newshacker-desktop1.webp";
import newshackerDesktop2 from "../../assets/newshacker/newshacker-desktop2.webp";
import newshackerDesktop3 from "../../assets/newshacker/newshacker-desktop3.webp";

export default function Portfolio() {
  // Desktop images first, mobile images last
  const allImages = [
    // Desktop images
    carbonDesktop2,
    carbonDesktop3,
    carbonDesktop,
    deutscheDesktop,
    deutscheDesktop2,
    deutscheDesktop3,
    deutscheDesktop4,
    bpDesktop,
    bpDesktop2,
    o2Desktop,
    o2Desktop2,
    newshackerDesktop,
    newshackerDesktop1,
    newshackerDesktop2,
    newshackerDesktop3,
    // Mobile images
    carbonMobile,
    deutscheMobile,
    deutscheMobile2,
    deutscheMobile3,
    bpMobile,
    o2Mobile,
  ];

  return (
    <MainTemplate>
      <CollageGallery images={allImages} />
    </MainTemplate>
  );
}
